import script from "./PriceBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceBlock.vue?vue&type=script&setup=true&lang=ts"

import "./PriceBlock.vue?vue&type=style&index=0&id=3043ec63&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3043ec63"]])

export default __exports__